import { MatDialogConfig } from '@angular/material/dialog'

export const termsConditionsDialogConfig: MatDialogConfig<null> = {
    autoFocus: false,
    disableClose: true,
    height: '600px',
    panelClass: 'dialog',
    width: '600px',
}
